import app from '@/app';
import angular from 'angular';
import templateUrl from './measurement-table.html';

/* @ngInject */
function Controller($controller, $httpParamSerializer, $state, DialogService, Principal) {
	var $ctrl = this;
	$controller('AbstractPageSortController', { $ctrl });

	var transition = $ctrl.transition;
	$ctrl.transition = params => {
		transition(params);
		$ctrl.params = angular.extend({}, params);
		$ctrl.resource = $ctrl.parent.allResources[params.measurement];
		$ctrl.measurement = $ctrl.parent.allMeasurements.find(it => it.code == params.measurement);
		$ctrl.metrics = $ctrl.parent.allMetrics.filter(it => it.measurement == params.measurement && it.measurement != 'icp');
		$ctrl.resource.query(
			params,
			data => {
				$ctrl.entities = data.content;
				$ctrl.count = data.totalElements;
				$ctrl.exportLink =
					'/api/' + $ctrl.measurement.name + 's/excel?' + $httpParamSerializer($ctrl.params);
			},
			() => $ctrl.recoverFromQueryError(params)
		);
	};

	// On a backend query failure (e.g. an unsupported sort column), drop the offending sort so the
	// table reloads in a working state instead of staying frozen on the bad parameters.
	$ctrl.recoverFromQueryError = params => {
		if (!params.sort) {
			return;
		}
		$state.go($state.current, angular.extend({}, params, { sort: null }), { reload: true });
	};

  $ctrl.currentAccount = null;

  Principal.identity().then(account => {
	$ctrl.currentAccount = account;
	})

	$ctrl.remove = () =>
		$ctrl.resource.purge($ctrl.params, () => $ctrl.transition($ctrl.params)).$promise;
}

app.component('measurementTable', {
	templateUrl,
	controller: Controller,
	require: {
		parent: '^measurementSearch'
	},
	bindings: {
		measurement: '<',
		$transition$: '<'
	}
});
